import React from 'react';
import { useTranslation } from '../contexts/LanguageContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from './ui/dropdown-menu';
import { Globe } from 'lucide-react';

const LANGUAGE_LABELS = {
  it: 'Italiano',
  en: 'English',
  es: 'Español',
  fr: 'Français',
  de: 'Deutsch',
};

export default function LanguageSwitcher({ variant = 'dark' }) {
  const { language, setLanguage, languages } = useTranslation();
  const isDark = variant === 'dark';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="flex items-center gap-1.5 rounded-[10px] px-2.5 py-2 text-[13px] font-semibold transition-colors"
          style={isDark
            ? { color: '#9AA8C2', background: 'transparent' }
            : { color: '#46546E', border: '1px solid #E4E8EF' }}
          data-testid="language-switcher"
        >
          <Globe className="w-[16px] h-[16px]" />
          {LANGUAGE_LABELS[language] || language.toUpperCase()}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang}
            onClick={() => setLanguage(lang)}
            data-testid={`language-option-${lang}`}
          >
            {LANGUAGE_LABELS[lang] || lang.toUpperCase()}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
